// extracted by mini-css-extract-plugin
export default {"button":"FlatButton_button__8CIwT"};